import React, { useMemo, useRef, useState } from "react";
import "./OrderWeightInfoPopup.css";
import Icons from "../../../../../../Config/Images";
import { useNavigate } from "react-router-dom";

const OrderWeightInfoPopup = ({ onClose, cartBrands = [] }) => {
  const navigate = useNavigate();

  // First tab is always "All", then one per brand
  const [activeTab, setActiveTab] = useState("All");

  const tabsRef = useRef(null);

  const scrollTabs = (direction) => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({
        left: direction === "left" ? -150 : 150,
        behavior: "smooth",
      });
    }
  };

  // Grand totals across all brands
  const totals = useMemo(() => {
    return cartBrands.reduce(
      (acc, brand) => ({
        product_count: acc.product_count + Number(brand.product_count || 0),
        total_net_weight:
          acc.total_net_weight + parseFloat(brand.total_net_weight || 0),
        total_fine: acc.total_fine + parseFloat(brand.total_fine || 0),
      }),
      { product_count: 0, total_net_weight: 0, total_fine: 0 },
    );
  }, [cartBrands]);

  // Currently selected brand data (null when "All" tab)
  const activeBrand =
    activeTab === "All"
      ? null
      : cartBrands.find((b) => b.manufacturer_id === activeTab);

  // What to render in the content area
  const displayData =
    activeTab === "All"
      ? {
          product_count: totals.product_count,
          total_net_weight: totals.total_net_weight.toFixed(3),
          total_fine: totals.total_fine.toFixed(3),
        }
      : {
          product_count: activeBrand?.product_count ?? "-",
          total_net_weight: parseFloat(
            activeBrand?.total_net_weight || 0,
          ).toFixed(3),
          total_fine: parseFloat(activeBrand?.total_fine || 0).toFixed(3),
        };

  if (!cartBrands.length) return null;

  const showScrollButtons = cartBrands.length >= 2;
  return (
    <div className="overlay-order-weight-popup">
      <div className="modal-order-weight-popup">
        <div className="header-div-order-weight-popup">
          <h2 className="title-order-weight-popup">Order Summary</h2>
        </div>
        <img
          onClick={onClose}
          className="cross-ico-order-weight-popup"
          src={Icons?.cross_icon}
          alt="Close"
        />

        {/* Tabs: All + one per brand */}
        {/* <div className="tabContainer-order-weight-popup">
          <div
            className={
              activeTab === "All"
                ? "tabActive-order-weight-popup"
                : "tab-order-weight-popup"
            }
            onClick={() => setActiveTab("All")}
          >
            All
          </div>
          {cartBrands.map((brand) => (
            <div
              key={brand.manufacturer_id}
              className={
                activeTab === brand.manufacturer_id
                  ? "tabActive-order-weight-popup"
                  : "tab-order-weight-popup"
              }
              onClick={() => setActiveTab(brand.manufacturer_id)}
            >
              {brand.brand_name.trim()}
            </div>
          ))}
        </div> */}

        {/* Tabs */}
        <div className="tabsWrapper-order-weight-popup">
          {showScrollButtons && (
            <button
              className="scrollBtn-order-weight-popup"
              onClick={() => scrollTabs("left")}
            >
              ◀
            </button>
          )}

          <div className="tabContainer-order-weight-popup" ref={tabsRef}>
            <div
              className={
                activeTab === "All"
                  ? "tabActive-order-weight-popup"
                  : "tab-order-weight-popup"
              }
              onClick={() => setActiveTab("All")}
            >
              All
            </div>

            {cartBrands.map((brand) => (
              <div
                key={brand.manufacturer_id}
                className={
                  activeTab === brand.manufacturer_id
                    ? "tabActive-order-weight-popup"
                    : "tab-order-weight-popup"
                }
                onClick={() => setActiveTab(brand.manufacturer_id)}
              >
                {brand.brand_name.trim()}
              </div>
            ))}
          </div>

          {showScrollButtons && (
            <button
              className="scrollBtn-order-weight-popup"
              onClick={() => scrollTabs("right")}
            >
              ▶
            </button>
          )}
        </div>

        {/* Content */}
        <div className="content-order-weight-popup">
          <div className="row-order-weight-popup">
            <span>Product Count</span>
            <span>{displayData.product_count}</span>
          </div>
          <div className="row-order-weight-popup">
            <span>Net Weight</span>
            <span>{displayData.total_net_weight}</span>
          </div>
          <div className="row-order-weight-popup last-row-order-weight-popup">
            <span>Fine</span>
            <span>{displayData.total_fine}</span>
          </div>

          <button
            className="viewCartButton-order-weight-popup"
            onClick={() => navigate("/cart-brands")}
          >
            View Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderWeightInfoPopup;
